import { render, staticRenderFns } from "./asset-allocations.vue?vue&type=template&id=9d78941c&"
import script from "./asset-allocations.vue?vue&type=script&lang=js&"
export * from "./asset-allocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports